var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5704_347)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5704_347",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 24,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.09088H24V22.9091H0V1.09088Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5704_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5547 19.8197H2.47459C2.06315 19.8197 1.72961 19.5087 1.72961 19.1251V4.84386C1.72961 4.47726 2.04836 4.18003 2.4416 4.18003H7.61064C7.84868 4.18003 8.07095 4.29095 8.20305 4.47564L9.62703 6.46719C9.7475 6.63568 9.9503 6.73685 10.1675 6.73685H18.1122C18.5055 6.73685 18.8242 7.03408 18.8242 7.40068V10.9743",
    stroke: "#1D2939",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5545 19.8197L22.1579 12.5825C22.5215 11.8523 21.9495 11.0169 21.0861 11.0169H6.61694C6.14679 11.0169 5.72137 11.2767 5.53362 11.6786L1.83301 19.5979",
    stroke: "#1D2939",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5704_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.31fd2fef110ccc912c5c21a17d0144ab.svg";
export { ForwardRef as ReactComponent };